import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import BoldLabel from '@Components/UI/Label';
import { getBaseTheme } from '@Themes';

const { texts, spaces } = getBaseTheme();

export const PartyItem = styled.div`
    &:hover {
        background-color: #c0d5dc; // TODO-TH
        cursor: default;
    }
    display: inline-block;
`;

export const Title = styled(BoldLabel)`
    padding-top: ${spaces.default.xs};

    &:first-child {
        padding-top: 0;
    }
`;

export const GenerateExportedDocxButtonWrapper = styled.div`
    display: inline;
    button:focus {
        outline: none;
    }
`;

export const SpinnerWrapper = styled.div`
    display: inline-flex;
    padding-top: ${spaces.default.xxxs};
    padding-left: ${spaces.default.xxxs};
`;

export const ErrorText = styled(textblocks.Text)`
    display: block;
    color: red;
    font-weight: bold;
    ${texts.sizes.s};
`;

export const CancelButtonWrapper = styled.div`
    float: left;
    display: inline;
`;

export const DownoladButtonWrapper = styled.div`
    float: right;
    display: inline;

    a {
        text-decoration: none;
    }
`;

export const DownloadDialogWrapper = styled.div`
    padding: ${spaces.default.s};
    line-height: 2rem;
    background-color: #fff;
`;

export const FileName = styled.span`
    overflow-wrap: break-word;

    // IE11 fix to wrap long FileName
    word-break: break-all;
    display: inline-block;
`;

export const LinkButtonWrapper = styled.div`
    float: right;
    display: inline;
    padding-right: 0.25rem;
`;

export const ModalDialogFooter = styled.div`
    margin-top: ${spaces.default.m};
`;
